<header class="profile-header">
  <app-font-toggle class="profile-header__font-toggle" />

  <div class="profile-header__avatar-wrap">
    <img
      src="profile-picture-leesey.jpg"
      alt="Leesey Reviews profile"
      class="profile-header__avatar"
      width="108"
      height="108"
    />
  </div>

  <h1 class="profile-header__username"><span class="profile-header__at">&#64;</span>leesey.reviews</h1>

  <ul class="profile-header__tags">
    <li class="profile-header__tag">
      <i class="fa-solid fa-stethoscope profile-header__tag-icon"></i>
      <span>ED Nurse</span>
    </li>
    <li class="profile-header__tag">
      <i class="fa-solid fa-book profile-header__tag-icon"></i>
      <span>Thriller &amp; Romance Junkie</span>
    </li>
    <li class="profile-header__tag">
      <i class="fa-solid fa-feather profile-header__tag-icon"></i>
      <span>Dyslexic Author</span>
    </li>
  </ul>

  <div class="profile-header__location">
    <span class="profile-header__dot"></span>
    <span class="profile-header__location-label">New Zealand</span>
  </div>
</header>
